import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const aiProcessingLogService = createApi({
  reducerPath: "aiProcessingLogService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["aiProcessingLog"],
  endpoints: (builder) => ({
    getAllAIProcessingLogs: builder.mutation({
      query: (body) => ({
        headers: { Authorization: `Bearer ${body.token}` },
        url: userManagement.aiProcessingLogController.getAll,
        method: "GET",
      }),
    }),
    getAIProcessingLogById: builder.mutation({
      query: (body) => ({
        headers: { Authorization: `Bearer ${body.token}` },
        url: `${userManagement.aiProcessingLogController.getById}/${body.id}`,
        method: "GET",
      }),
    }),
    saveAIProcessingLog: builder.mutation({
      query: (body) => ({
        headers: { Authorization: `Bearer ${body.token}` },
        url: userManagement.aiProcessingLogController.save,
        method: "POST",
        body: body.payload,
      }),
    }),
    updateAIProcessingLog: builder.mutation({
      query: (body) => ({
        headers: { Authorization: `Bearer ${body.token}` },
        url: `${userManagement.aiProcessingLogController.update}/${body.payload.id}`,
        method: "PUT",
        body: body.payload,
      }),
    }),
    deleteAIProcessingLog: builder.mutation({
      query: (body) => ({
        headers: { Authorization: `Bearer ${body.token}` },
        url: `${userManagement.aiProcessingLogController.delete}/${body.id}`,
        method: "DELETE",
      }),
    }),
    searchAIProcessingLogs: builder.mutation({
      query: (body) => ({
        headers: { Authorization: `Bearer ${body.token}` },
        url: userManagement.aiProcessingLogController.search,
        method: "POST",
        body: body.payload,
      }),
    }),
    getAllAIProcessingLogsWithPagination: builder.mutation({
      query: (body) => ({
        headers: { Authorization: `Bearer ${body.token}` },
        url: `${userManagement.aiProcessingLogController.getAllWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
      }),
    }),
    uploadBulkAIProcessingLogs: builder.mutation({
      query: (body) => {
        return {
          headers: { Authorization: `Bearer ${body.token}` },
          url: userManagement.aiProcessingLogController.uploadBulk,
          method: "POST",
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useGetAllAIProcessingLogsMutation,
  useGetAIProcessingLogByIdMutation,
  useSaveAIProcessingLogMutation,
  useUpdateAIProcessingLogMutation,
  useDeleteAIProcessingLogMutation,
  useSearchAIProcessingLogsMutation,
  useGetAllAIProcessingLogsWithPaginationMutation,
  useUploadBulkAIProcessingLogsMutation,
} = aiProcessingLogService;
